import React from 'react';
import { Container } from 'react-bootstrap';

const Privacy: React.FC = () => {
  return (
    <Container className="py-5">
      <h2>Privacy Policy</h2>
      <div className="mt-4">
        <h3>1. Information Collection</h3>
        <p>We collect transaction data and wallet addresses necessary for processing cryptocurrency exchanges.</p>

        <h3>2. Data Usage</h3>
        <p>Your data is used solely for processing transactions and improving our service quality.</p>

        <h3>3. Data Protection</h3>
        <p>We implement industry-standard security measures to protect your information.</p>

        <h3>4. Cookies</h3>
        <p>We use essential cookies to ensure the proper functioning of our platform.</p>

        <h3>5. Third-Party Services</h3>
        <p>We may use third-party services for transaction processing and analytics.</p>

        <h3>6. User Rights</h3>
        <p>You have the right to access, correct, or delete your personal information.</p>

        <h3>7. Data Retention</h3>
        <p>We retain transaction data as required by applicable laws and regulations.</p>

        <h3>8. Changes to Privacy Policy</h3>
        <p>We may update this policy periodically. Continued use implies acceptance of changes.</p>

        <h3>9. Contact Us</h3>
        <p>For privacy-related inquiries, please contact our support team.</p>
      </div>
    </Container>
  );
};

export default Privacy;